import React, { Component } from "react";
import { Subscribe } from "unstated";
import StateContainer from "../../../state/StateContainer";

import "./CompareToggleView.css";

class CompareToggleView extends Component {
  constructor() {
    super();

    this.state = {
      buttonTypes: {
        D2: "2d",
        D3: "3d",
      },
      activeButton: "2d",
    };
  }

  handleButtonClicked = (buttonType) => {
    this.setState({ activeButton: buttonType });
  };

  handle2dButtonClicked = () => {
    this.handleButtonClicked(this.state.buttonTypes.D2);
    this.hideViewContainer("D3");
  };

  handle3dButtonClicked = () => {
    this.handleButtonClicked(this.state.buttonTypes.D3);
    this.hideViewContainer("D2");
  };

  /**
   * Hides active compare container
   * @param containerType type of container to hide
   */
  hideViewContainer = (containerType) => {
    const containers = {
      leftContainer: () => {
        this.props.unstated.setState({
          leftApartmentStyles: {
            ...this.props.unstated.leftApartmentStyles,
            [containerType]: { display: "none" },
          },
        });

        if (containerType === "D2") {
          this.setActive3DViewContainer("left");
        }
      },
      rightContainer: () => {
        this.props.unstated.setState({
          rightApartmentStyles: {
            ...this.props.unstated.rightApartmentStyles,
            [containerType]: { display: "none" },
          },
        });

        if (containerType === "D2") {
          this.setActive3DViewContainer("right");
        }
      },
    };

    if (containers[this.props.activeContainer])
      return containers[this.props.activeContainer]();
  };

  /**
   * Set the state with which we will know that the 3d container is active in order to create scene
   * @param containerType type of container to hide
   */
  setActive3DViewContainer = (container3DType) => {
    if (container3DType === "left") {
      this.props.unstated.setState({
        leftCompare3DContainerActive: true,
      });
    }

    if (container3DType === "right") {
      this.props.unstated.setState({
        rightCompare3DContainerActive: true,
      });
    }
  };

  render() {
    return (
      <div className="toggle-container">
        <div className="toggle-container__button">
          <span className="span-type">2D</span>
          <span className="span-plan">PLAN</span>
          <div
            className={`toggle-container__button-image 
              image-2d 
              ${
                this.state.activeButton === this.state.buttonTypes.D2 &&
                "button-active"
              }`}
            onClick={this.handle2dButtonClicked}
          ></div>
        </div>
        <div className="toggle-container__button">
          <div
            className={`toggle-container__button-image
            image-3d ${
              this.state.activeButton === this.state.buttonTypes.D3 &&
              "button-active"
            }`}
            onClick={this.handle3dButtonClicked}
          ></div>
          <span className="span-type">3D</span>
          <span className="span-plan">PLAN</span>
        </div>
      </div>
    );
  }
}

const CompareToggleViewWithUnstated = (props) => {
  return (
    <Subscribe to={[StateContainer]}>
      {(unstated) => <CompareToggleView {...props} unstated={unstated} />}
    </Subscribe>
  );
};

export default CompareToggleViewWithUnstated;
